import { useRef, useState } from "react";
import useOnClickOutside from "../../shared/hooks/useOnClickOutside";
import Icon, { IconsVariant } from "../Icon/Icon";
import Helper from "./Helper";

interface HelperModalProps {
  variants?: IconsVariant;
  children?: React.ReactNode;
  bg?: string;
  text?: string;
  onClose?: () => void;
}

const HelperModal = ({
  children,
  variants = "question",
  bg = "primary",
  text,
  onClose,
}: HelperModalProps) => {
  const [active, setActive] = useState(false);
  const ref = useRef();
  useOnClickOutside(ref, () => {
    onClose && onClose();
    setActive(false);
  });
  return (
    <div ref={ref} className="md:block">
      <Helper
        bg={bg}
        text={text}
        variants={variants}
        onClick={() => setActive(!active)}
      />
      <div
        className="fixed bottom-0 right-0 z-[3] bg-white p-12 md:min-w-[55rem]"
        style={{
          boxShadow: `0px 0px 15px 0px rgba(0,0,0,0.28)`,
          transform: `translateX(${active ? "0rem" : "100rem"})`,
          transition: "all 300ms",
        }}
      >
        <div onClick={() => {
            onClose && onClose();
            setActive(false);
          }} className="cursor-pointer right-[1.5rem] top-[1rem] absolute">
          <Icon className="h-6 w-6 fill-primary" variants={"times"} />
        </div>
        {active && children}
      </div>
    </div>
  );
};

export default HelperModal;
